import { render } from "./MainNavigation.vue?vue&type=template&id=4809c222&ts=true"
import script from "./MainNavigation.vue?vue&type=script&lang=ts"
export * from "./MainNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__